<template>
  <base-dropdown
    v-model="localLanguage"
    :icon-for-read-only-value="selectedLanguageFlag"
    :entries="languageList"
    :label="label"
    :required="required"
    :is-read-only="isReadOnly"
    @select="onLanguageChange"
  />
</template>

<script>
import {
  defaultLocale,
  getLanguageCodeFrom,
  supportedLocaleEntries,
  supportedLanguageEntries,
} from "@/utils/locales";
import BaseDropdown from "@/components/ui/BaseDropdown.vue";
import cloneDeep from "lodash/cloneDeep";

// @vuese
// component for picking a language
// @group 4. UI/Advanced
export default {
  components: { BaseDropdown },
  props: {
    value: {
      type: String,
      default: defaultLocale,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    // Only display base locale entries (en, it, fr), not (en-GB, en-US, ...)
    displayBaseLocalesOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localLanguage: "",
    };
  },
  mounted() {
    this.updateSelectedLanguage();
  },
  methods: {
    onLanguageChange(language) {
      this.localLanguage = language;
      this.$emit("input", language);
    },
    updateSelectedLanguage() {
      this.localLanguage = cloneDeep(this.value);

      // Certain locales values e.g. 'en' must be fit against the available one e.g. 'en-US'.
      // We thus put the first value having the matching base locale in that case.
      if (!this.languageList[this.localLanguage]) {
        const clippedLocale =
          getLanguageCodeFrom(this.localLanguage) || defaultLocale;
        const selectedLocale = Object.values(this.languageList).find(
          (e) => e.id === clippedLocale || e.baseLocale === clippedLocale
        );
        this.localLanguage = selectedLocale.id;
      }
    },
  },
  computed: {
    selectedLanguageFlag() {
      let selectedLocale = this.languageList[this.localLanguage];
      return selectedLocale ? selectedLocale.icon : "";
    },
    languageList() {
      const entries = {};
      const entriesArray = this.displayBaseLocalesOnly
        ? supportedLanguageEntries
        : supportedLocaleEntries;
      entriesArray.forEach((e) => {
        entries[e.short] = {
          id: e.short,
          name: e.long,
          icon: `flags/${e.flagIso3166}`,
          baseLocale: e.root || e.key,
        };
      });

      return entries;
    },
  },
  watch: {
    value() {
      this.updateSelectedLanguage();
    },
  },
};
</script>
